<template>
  <v-container fluid>
    <v-card class="pa-10">
      <!-- <v-card class="ma-5" elevation="0"> -->
      <v-row>
        <v-col cols="12" md="6">
          <v-card-title class="text-h5">Trademark Matter</v-card-title>
        </v-col>
        <v-col align="right" color="primary" cols="12" md="6" class="d-flex justify-end">
          <v-btn to="/master-trademark-add" color="#0A7EA5" rounded dark class="mb-2" :disabled="!authorize_add">
            <span>Add</span>
            <v-icon small center>add</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <v-row class="align-start">
            <v-col cols="12" md="7">
              <v-text-field v-model="search_tmp" outlined dense v-on:keyup.enter="onSearchPagination"
                label="Search"></v-text-field>
              <h4 class="text-danger red--text mt-n7">
                * input text and enter for search
              </h4>
            </v-col>
            <v-col cols="12" md="5">
              <v-autocomplete clearable @click:clear="
                $nextTick(() => {
                  tmstatus = 0;
                })
                " v-model="tmstatus" :items="tmstatus_list" item-text="tmupdatestatus_name"
                item-value="tmupdatestatus_id" outlined @change="onSearchPagination" dense
                label="Status"></v-autocomplete>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="6" class="d-flex justify-end mt-n6">
          <v-row>
            <v-col cols="12" md="3" class="d-flex justify-center align-center" offset="1">
              Next Renewal Date :
            </v-col>

            <v-col cols="12" md="4">
              From
              <v-menu v-model="menuadddatefrom" :close-on-content-click="false" :nudge-right="40"
                transition="scale-transition" offset-y min-width="290" max-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="searchdatefrom" clearable @click:clear="
                    $nextTick(() => {
                      searchdatefromS = null;
                      searchdatefrom = null;
                      searchdateto = null;
                      searchdatetoPicker = null;
                      onSearchPagination();
                    })
                    " persistent-hint hint="Format DD/MM/YYYY" @keydown.enter="onSearchPagination"
                    append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense readonly></v-text-field>
                </template>

                <v-date-picker v-model="searchdatefromPicker" @input="
                  () => {
                    searchdatefrom =
                      formatDateToDDMMYYYY(searchdatefromPicker);
                    menuadddatefrom = false;
                    onSearchPagination();
                  }
                "></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" md="4">
              To
              <v-menu v-model="menuadddateto" :close-on-content-click="false" :nudge-right="40"
                transition="scale-transition" offset-y min-width="290" max-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field clearable @click:clear="
                    $nextTick(() => {
                      searchdatefromS = null;
                      searchdatefrom = null;
                      searchdateto = null;
                      searchdatetoPicker = null;
                      onSearchPagination();
                    })
                    " v-model="searchdateto" persistent-hint hint="Format DD/MM/YYYY"
                    @keydown.enter="onSearchPagination" append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined
                    dense readonly></v-text-field>
                </template>

                <v-date-picker v-model="searchdatetoPicker" @input="
                  () => {
                    searchdateto = formatDateToDDMMYYYY(searchdatetoPicker);
                    menuadddateto = false;
                    onSearchPagination();
                  }
                "></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <br />

      <v-card outlined tile>
        <!-- <v-data-table
          :items-per-page-options="pageSizes"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          @page-count="pageCount = $event"
          :search="search"
          :headers="headers"
          :items="mDataArray"
          class="elevation-1"
          :footer-props="{
            'items-per-page-options': [5, 10, 15, 100, -1],
            showFirstLastPage: true,
            firstIcon: 'mdi-arrow-collapse-left',
            lastIcon: 'mdi-arrow-collapse-right',
            prevIcon: 'mdi-minus',
            nextIcon: 'mdi-plus',
          }"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
              class="ml-1"
              :style="{
                backgroundColor: '#E1F5FE',
                color: '#2196F3',
              }"
              @click="openeditItem(item.mastertm_id)"
              v-if="authorize_edit"
            >
              mdi-pencil
            </v-icon>

            <v-icon
              class="ml-1"
              :style="{
                backgroundColor: '#FFEBEE',
                color: '#F44336',
              }"
              @click="deleteItem(item)"
              v-if="authorize_del"
            >
              mdi-delete
            </v-icon>

            <v-icon
              class="ml-1"
              :style="{
                backgroundColor: '#dbd7d0',
                color: '#6E6658',
              }"
              @click="openAppointmentadd(item.file_no)"
              v-if="authorize_add"
            >
              mdi-calendar-plus
            </v-icon>

            <v-icon
              v-if="item.appointment_refno != 0"
              :style="{
                backgroundColor: '#d7dee0',
                color: '#183981',
              }"
              @click="openAppointmentedit(item.file_no)"
            >
              mdi-calendar-check
            </v-icon>

            <v-icon
              :style="{
                backgroundColor: '#CCE7D8',
                color: '#11733D',
              }"
              @click="openPrintAppNo(item)"
            >
              mdi-printer
            </v-icon>
          </template>
        </v-data-table>

        <v-progress-linear
          indeterminate
          color="teal"
          v-if="load_bg"
        ></v-progress-linear> -->

        <!-- Pagination Section -->
        <div>
          <v-select v-model="itemsPerPage" @change="onSearchPagination" style="width: 150px" :items="item_per_page_list"
            label="Items per page" dense outlined hide-details></v-select>
        </div>
        <div>
          <div class="text-center pt-2">
            <v-pagination class="ma-3" v-model="page" :length="pageCount" @input="loadDataByPage"
              total-visible="19"></v-pagination>
          </div>

          <v-data-table :headers="headers" :items="mDataArray2" :server-items-length="totalItems"
            :options.sync="options" @update:options="onOptionsUpdate" hide-default-footer class="elevation-1"
            :loading="tableLoading" loading-text="Loading... Please wait">
            <!-- Custom loading slot สำหรับแสดง loading แบบวงกลม -->
            <template v-slot:progress>
              <div class="text-center pa-6">
                <v-progress-circular indeterminate color="primary" size="50" width="8"></v-progress-circular>
                <div class="mt-3 text-subtitle-1 primary--text">
                  กำลังโหลดข้อมูล...
                </div>
              </div>
            </template>
            <template v-slot:[`item.number_file`]="{ item }">
              <v-icon v-if="item.number_file" class="preview-btn" small
                @click="previewTrademarkImage(item)">mdi-image</v-icon>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon class="ml-1" :style="{
                backgroundColor: '#E1F5FE',
                color: '#2196F3',
              }" @click="openeditItem(item.mastertm_id)" v-if="authorize_edit">
                mdi-pencil
              </v-icon>

              <v-icon class="ml-1" :style="{
                backgroundColor: '#FFEBEE',
                color: '#F44336',
              }" @click="deleteItem(item)" v-if="authorize_del">
                mdi-delete
              </v-icon>
              <span v-if="authorize_add && item.tmupdatestatus_name == 'Closed'"
                @click="openeAppoinmentOperationforClosed(item)" class="v-icon ml-1" :style="{
                  cursor: 'pointer',
                  width: '24px',
                  height: '24px',
                  backgroundColor: '#E1F5FE',
                  color: '#254E58',
                }">
                <v-img src="@/assets/Reopen_icon.png" alt="restore"
                  style="width: 100%; height: 100%; object-fit: cover" />
              </span>
              <v-icon v-if="authorize_add && item.tmupdatestatus_name != 'Closed'" class="ml-1" :style="{
                backgroundColor: '#dbd7d0',
                color: '#6E6658',
              }" @click="openAppointmentadd(item.file_no)">
                mdi-calendar-plus
              </v-icon>

              <v-icon v-if="item.appointment_refno != 0" :style="{
                backgroundColor: '#d7dee0',
                color: '#183981',
              }" @click="openAppointmentedit(item.file_no)">
                mdi-calendar-check
              </v-icon>

              <v-icon :style="{
                backgroundColor: '#CCE7D8',
                color: '#11733D',
              }" @click="openPrintAppNo(item)">
                mdi-printer
              </v-icon>
            </template>
          </v-data-table>
        </div>
      </v-card>

      <!-- Popup delete  -->
      <v-dialog v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogAppointment" max-width="1200px">
        <v-card>
          <div>
            <v-card-title class="text-h4 black--text">Matter Timeline All Docket</v-card-title>
            <!-- <v-card outlined tile> -->
            <v-timeline dense v-if="showtimelineData.length > 0">
              <v-timeline-item v-for="item in showtimelineData" :key="item.id" color="primary" small>
                <v-card class="pa-3">
                  <v-row align="center">
                    <v-col cols="12" sm="6" md="6">
                      <div>{{ item.show_date }}</div>
                      <br />
                      <div style="margin-top: -20px">
                        {{
                          item.documenttype_code ? item.documenttype_code : ""
                        }}
                      </div>
                      <div v-if="item.documenttype_actions">
                        <ul>
                          <li v-for="(act, i) in JSON.parse(
                            item.documenttype_actions
                          )" :key="i" style="font-size: 0.8rem; color: gray">
                            {{ act.name }}
                          </li>
                        </ul>
                      </div>
                      <!-- <div
                              v-for="datadocumenttype_actions in JSON.parse(
                                item.documenttype_actions
                              )"
                              style="font-size: 0.8rem; color: gray"
                            >
                              - {{ datadocumenttype_actions.name }}
                            </div> -->
                    </v-col>
                    <v-col cols="12" sm="5" md="5">
                      <v-row style="margin-top: -10px">
                        <v-col cols="12" sm="6" md="6">
                          <div class="d-flex" style="font-size: 0.7rem; color: blue">
                            <span v-if="
                              item.fullnameen_user_update ||
                              item.fullnameth_user_update
                            ">Last Updated {{ item.updated_date }}</span>
                            <span v-else>Last Updated -</span>
                          </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <div class="d-flex" style="font-size: 0.7rem; color: blue">
                            <span v-if="
                              item.fullnameen_user_update ||
                              item.fullnameth_user_update
                            ">Last Update By
                              {{
                                item.fullnameen_user_update
                                  ? item.fullnameen_user_update
                                  : item.fullnameth_user_update
                                    ? item.fullnameth_user_update
                                    : ""
                              }}</span>
                            <span v-else>Last Update By -</span>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row style="margin-top: -25px">
                        <v-col cols="12" sm="6" md="6">
                          <div class="d-flex" style="font-size: 0.7rem; color: blue">
                            <span v-if="item.created_date">Created Date {{ item.created_date }}</span>
                            <span v-else>Created Date -</span>
                          </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <div class="d-flex" style="font-size: 0.7rem; color: blue">
                            <span v-if="
                              item.fullnameen_user_create ||
                              item.fullnameth_user_create
                            ">Create By
                              {{
                                item.fullnameen_user_create
                                  ? item.fullnameen_user_create
                                  : item.fullnameth_user_create
                                    ? item.fullnameth_user_create
                                    : ""
                              }}</span>
                            <span v-else>Create By -</span>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="1" md="1" class="d-flex align-center justify-center">
                      <template>
                        <v-btn icon outlined color="primary" small @click="editItemtimeline(item)">
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                    </v-col>
                  </v-row>
                </v-card>
              </v-timeline-item>
            </v-timeline>
            <v-timeline dense v-else>
              <v-timeline-item>
                <v-card class="pa-3">
                  <v-row>
                    <v-col cols="12" sm="7" md="7">
                      <div>No Date</div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-timeline-item>
            </v-timeline>
            <!-- </v-card> -->
          </div>
        </v-card>
      </v-dialog>

      <template>
        <!--   :style="showprint" -->
        <page size="A4" class="aligncenter" id="mydivhtmltobase" :style="showprint">
          <div class="aligncenter">
            <div class="rowprpo mr30prpo mt30">
              <!-- <div class="col-md-8report"></div>
              <div class="col-md-4report">
                <h5 class="alignright colprpo ">
                  No :
                </h5>
              </div> -->
            </div>
            <div class="rowprpo aligncenter">
              <div class="col-md-12report mb-50 wordspacingsummary">
                <h2>Trade Mark Matter</h2>
              </div>
            </div>

            <div class="rowprpo ml95prpo mr95prpo col-md-12report">
              <h4>I. &nbsp;&nbsp;&nbsp; Correspondence and references</h4>
            </div>

            <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13">
              <div class="col-md-6report">
                <div class="rowprpo" style="margin-left: 93px">
                  <div class="col-md-3report textalignleft fontsize13">
                    Our Ref.:
                  </div>
                  <div class="col-md-8report textalignleft ml10-prpo fixonerow showdefaultunderline">
                    {{ print_data.file_no }}
                  </div>
                </div>
              </div>

              <div class="col-md-6report">
                <div class="rowprpo" style="margin-left: 20px">
                  <div class="col-md-2report textalignleft fontsize13">
                    Agent Ref.:
                  </div>
                  <div class="col-md-9report textalignleft fixonerow showdefaultunderline">
                    {{ print_data.cliant_ref }}
                  </div>
                </div>
              </div>
            </div>

            <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13">
              <div class="col-md-6report">
                <div class="rowprpo" style="margin-left: 93px">
                  <div class="col-md-3report textalignleft fontsize13">
                    Applicant:
                  </div>
                  <div class="col-md-8report textalignleft ml10-prpo fixonerow showdefaultunderline">
                    {{ print_data.trademark }}
                  </div>
                </div>
              </div>

              <div class="col-md-6report">
                <div class="rowprpo" style="margin-left: 20px">
                  <div class="col-md-2report textalignleft fontsize13">
                    Agent:
                  </div>
                  <div class="col-md-9report textalignleft fixonerow showdefaultunderline">
                    {{ print_data.agent_contact_name }}
                  </div>
                </div>
              </div>
            </div>

            <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13">
              <div class="col-md-6report">
                <div class="rowprpo" style="margin-left: 93px">
                  <div class="col-md-11report textalignleft fixfourrow">
                    Applicant's Address: &nbsp;
                    <span class="showdefaultunderline">
                      <!-- {{ print_data.trademark }} -->-
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-md-6report">
                <div class="rowprpo" style="margin-left: 20px">
                  <div class="col-md-11report textalignleft fixfourrow">
                    Agent's Address: &nbsp;
                    <span class="showdefaultunderline">
                      {{ print_data.agent_address_name }}</span>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div class="rowprpo ml30prpo mr30prpo col-md-12report">
              <div class="col-md-6report">
                <h4>II. &nbsp;&nbsp;&nbsp; Trademark and Filing Particulars</h4>
              </div>
              <div class="col-md-6report">
                <h4>&nbsp;&nbsp;&nbsp; Trademark Representation</h4>
              </div>
            </div>
            <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13">
              <div class="col-md-6report">
                <div class="rowprpo" style="margin-left: 93px">
                  <div class="col-md-12report textalignleft fontsize13">
                    Type: &nbsp;
                    <span><input type="checkbox" />&nbsp; work mark</span>
                    &nbsp;&nbsp;&nbsp;
                    <span style="margin-left: 26px"><input type="checkbox" />&nbsp; Device</span>
                  </div>
                </div>
                <br />
                <div class="rowprpo" style="margin-left: 128px">
                  <div class="col-md-12report textalignleft fontsize13">
                    <span><input type="checkbox" />&nbsp; 2D Trademark</span>
                    &nbsp;&nbsp;&nbsp;
                    <span style="margin-left: 7px"><input type="checkbox" />&nbsp; 3D Trademark</span>
                  </div>
                </div>
                <br />
                <div class="rowprpo" style="margin-left: 128px">
                  <div class="col-md-12report textalignleft fontsize13">
                    <span><input type="checkbox" />&nbsp; Combined mark</span>
                    &nbsp;&nbsp;&nbsp;
                    <span><input type="checkbox" />&nbsp; Combined of color</span>
                  </div>
                </div>
                <br />
                <div class="rowprpo" style="margin-left: 93px">
                  <div class="col-md-12report textalignleft fontsize13">
                    &nbsp; Use: &nbsp;
                    <span><input type="checkbox" />&nbsp; intent to use</span>
                    &nbsp;&nbsp;&nbsp;
                    <span style="margin-left: 17px"><input type="checkbox" />&nbsp; has been used</span>
                  </div>
                </div>
                <br />
                <div class="rowprpo" style="margin-left: 93px">
                  <div class="col-md-12report textalignleft fontsize13 fixonerow">
                    &nbsp; Class: &nbsp;
                    <span class="showdefaultunderline">{{
                      print_data.class_no
                    }}</span>
                  </div>
                </div>
              </div>

              <div class="col-md-6report">
                <div class="rowprpo" style="margin-left: 100px">
                  <v-img max-width="170" max-heigth="170" disabled :src="previewimageedit"
                    class="grey lighten-2 mt-3 mb-5" aspect-ratio="1" contain>
                  </v-img>
                </div>
              </div>
            </div>
            <br />
            <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13">
              <div class="col-md-6report">
                <div class="rowprpo" style="margin-left: 93px">
                  <div class="col-md-3report textalignleft fontsize13">
                    <input type="checkbox" /> Search
                  </div>
                  <div class="col-md-8report textalignleft ml10-prpo fixonerow showdefaultunderline">
                    <!-- {{ print_data.file_no }} -->
                    -
                  </div>
                </div>
              </div>

              <div class="col-md-6report">
                <div class="rowprpo" style="margin-left: 20px">
                  <div class="col-md-5report textalignleft fontsize13">
                    Date of conducting the search
                  </div>
                  <div class="col-md-6report textalignleft fixonerow showdefaultunderline">
                    <!-- {{ print_data.cliant_ref }} -->
                    -
                  </div>
                </div>
              </div>
            </div>

            <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13">
              <div class="col-md-6report">
                <div class="rowprpo" style="margin-left: 93px">
                  <div class="col-md-5report textalignleft fontsize13">
                    <input type="checkbox" /> Application No.
                  </div>
                  <div class="col-md-6report textalignleft ml20-prpo fixonerow showdefaultunderline">
                    {{ print_data.app_no }}
                  </div>
                </div>
              </div>

              <div class="col-md-6report">
                <div class="rowprpo" style="margin-left: 20px">
                  <div class="col-md-2report textalignleft fontsize13">
                    Filing Date
                  </div>
                  <div class="col-md-9report textalignleft fixonerow showdefaultunderline">
                    <!-- {{ print_data.cliant_ref }} -->
                    -
                  </div>
                </div>
              </div>
            </div>

            <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13">
              <div class="col-md-6report">
                <div class="rowprpo" style="margin-left: 93px">
                  <div class="col-md-4report textalignleft fontsize13">
                    <input type="checkbox" /> Publication Vol.
                  </div>
                  <div class="col-md-3report textalignleft fixonerow showdefaultunderline">
                    {{ print_data.val_no }}
                  </div>

                  <div class="col-md-1report textalignleft fontsize13">
                    Page
                  </div>
                  <div class="col-md-4report textalignleft fixonerow showdefaultunderline">
                    {{ print_data.page_no }}
                  </div>
                </div>
              </div>

              <div class="col-md-6report">
                <div class="rowprpo" style="margin-left: 20px">
                  <div class="col-md-3report textalignleft fontsize13">
                    Publication Date
                  </div>
                  <div class="col-md-8report textalignleft fixonerow showdefaultunderline">
                    {{ print_data.show_date_of_public }}
                  </div>
                </div>
              </div>
            </div>

            <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13">
              <div class="col-md-6report">
                <div class="rowprpo" style="margin-left: 93px">
                  <div class="col-md-5report textalignleft fontsize13">
                    <input type="checkbox" /> Registration No.
                  </div>
                  <div class="col-md-6report textalignleft ml20-prpo fixonerow showdefaultunderline">
                    {{ print_data.regis_no }}
                  </div>
                </div>
              </div>

              <div class="col-md-6report">
                <div class="rowprpo" style="margin-left: 20px">
                  <div class="col-md-3report textalignleft fontsize13">
                    Registration Date
                  </div>
                  <div class="col-md-8report textalignleft fixonerow showdefaultunderline">
                    {{ print_data.show_date_of_regis }}
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13">
              <div class="col-md-12report">
                <div class="rowprpo" style="margin-left: 93px">
                  <div class="col-md-12report textalignleft">
                    <h4>Limitations</h4>
                  </div>
                </div>
              </div>
            </div>

            <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13">
              <div class="col-md-12report">
                <div class="rowprpo" style="margin-left: 93px">
                  <div class="col-md-3report textalignleft fontsize13">
                    <input type="checkbox" /> Association requirement:
                  </div>
                  <div class="col-md-8report textalignleft ml20-prpo fixonerow showdefaultunderline">
                    <!-- {{ print_data.regis_no }} -->-
                  </div>
                </div>
              </div>
            </div>
            <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13">
              <div class="col-md-12report">
                <div class="rowprpo" style="margin-left: 93px">
                  <div class="col-md-3report textalignleft fontsize13">
                    <input type="checkbox" /> Disclaimer requirement:
                  </div>
                  <div class="col-md-8report textalignleft ml20-prpo fixonerow showdefaultunderline">
                    <!-- {{ print_data.regis_no }} -->-
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div class="rowprpo ml95prpo mr95prpo col-md-12report">
              <h4>III. &nbsp;&nbsp;&nbsp; Prosecution Details</h4>
            </div>

            <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13">
              <div class="col-md-6report">
                <div class="rowprpo" style="margin-left: 93px">
                  <div class="col-md-3report textalignleft fontsize13">
                    <input type="checkbox" /> Evidence
                  </div>
                  <div class="col-md-8report textalignleft ml10-prpo fixonerow showdefaultunderline">
                    <!-- {{ print_data.file_no }} -->
                  </div>
                </div>
              </div>

              <div class="col-md-6report">
                <div class="rowprpo" style="margin-left: 20px">
                  <div class="col-md-4report textalignleft fontsize13">
                    Date of filing evidence
                  </div>
                  <div class="col-md-7report textalignleft fixonerow showdefaultunderline">
                    <!-- {{ print_data.cliant_ref }} -->
                    -
                  </div>
                </div>
              </div>
            </div>

            <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13">
              <div class="col-md-6report">
                <div class="rowprpo" style="margin-left: 93px">
                  <div class="col-md-6report textalignleft fontsize13">
                    <input type="checkbox" /> Encounter opposition
                  </div>
                  <div class="col-md-5report textalignleft ml10-prpo fixonerow showdefaultunderline">
                    <!-- {{ print_data.file_no }} -->
                  </div>
                </div>
              </div>

              <div class="col-md-6report">
                <div class="rowprpo" style="margin-left: 20px">
                  <div class="col-md-5report textalignleft fontsize13">
                    Date of filing an opposition:
                  </div>
                  <div class="col-md-6report textalignleft fixonerow showdefaultunderline">
                    {{ print_data.show_date_of_opposition }}
                  </div>
                </div>
              </div>
            </div>

            <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13">
              <div class="col-md-6report">
                <div class="rowprpo" style="margin-left: 93px">
                  <div class="col-md-8report textalignleft fontsize13">
                    <input type="checkbox" /> Submitting a counter statement
                  </div>
                  <div class="col-md-3report textalignleft ml10-prpo fixonerow showdefaultunderline">
                    <!-- {{ print_data.file_no }} -->
                  </div>
                </div>
              </div>

              <div class="col-md-6report">
                <div class="rowprpo" style="margin-left: 20px">
                  <div class="col-md-6report textalignleft fontsize13">
                    Date of filing a counter statement:
                  </div>
                  <div class="col-md-5report textalignleft fixonerow showdefaultunderline">
                    <!-- {{ print_data.cliant_ref }} -->
                    -
                  </div>
                </div>
              </div>
            </div>

            <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13">
              <div class="col-md-6report">
                <div class="rowprpo" style="margin-left: 93px">
                  <div class="col-md-4report textalignleft fontsize13">
                    <input type="checkbox" /> Appeal
                  </div>
                  <div class="col-md-7report textalignleft ml10-prpo fixonerow showdefaultunderline">
                    <!-- {{ print_data.file_no }} -->
                  </div>
                </div>
              </div>

              <div class="col-md-6report">
                <div class="rowprpo" style="margin-left: 20px">
                  <div class="col-md-4report textalignleft fontsize13">
                    Date of filing an appeal:
                  </div>
                  <div class="col-md-7report textalignleft fixonerow showdefaultunderline">
                    <!-- {{ print_data.cliant_ref }} -->
                    -
                  </div>
                </div>
              </div>
            </div>

            <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13">
              <div class="col-md-6report">
                <div class="rowprpo" style="margin-left: 93px">
                  <div class="col-md-8report textalignleft fontsize13">
                    <input type="checkbox" /> The case is instigated to the
                    Court
                  </div>
                  <div class="col-md-3report textalignleft ml10-prpo fixonerow showdefaultunderline">
                    <!-- {{ print_data.file_no }} -->
                  </div>
                </div>
              </div>

              <div class="col-md-6report">
                <div class="rowprpo" style="margin-left: 20px">
                  <div class="col-md-3report textalignleft fontsize13">
                    Date of filing:
                  </div>
                  <div class="col-md-8report textalignleft fixonerow ml10-prpo showdefaultunderline">
                    <!-- {{ print_data.cliant_ref }} -->
                    -
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div class="rowprpo ml95prpo mr95prpo col-md-12report">
              <h4>IV. &nbsp;&nbsp;&nbsp; Maintenance</h4>
            </div>

            <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13">
              <div class="col-md-12report">
                <div class="rowprpo" style="margin-left: 93px">
                  <div class="col-md-2report textalignleft fontsize13">
                    <input type="checkbox" /> Renewal Date
                  </div>
                  <div class="col-md-9report textalignleft ml20-prpo fixonerow showdefaultunderline">
                    {{ print_data.show_date_of_renewal_filed }}
                  </div>
                </div>
              </div>
            </div>

            <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13">
              <div class="col-md-12report">
                <div class="rowprpo" style="margin-left: 93px">
                  <div class="col-md-5report textalignleft fontsize13">
                    <input type="checkbox" /> Affidavit of use/non-use (if
                    require for overseas)
                  </div>
                  <div class="col-md-6report textalignleft ml10-prpo fixonerow showdefaultunderline">
                    <!-- {{ print_data.file_no }} -->-
                  </div>
                </div>
              </div>
            </div>

            <div class="rowprpo ml30prpo mr30prpo aligncenter col-md-12report fontsize13">
              <div class="col-md-12report">
                <div class="rowprpo" style="margin-left: 93px">
                  <div class="col-md-12report textalignleft fixtworow">
                    Remarks:&nbsp;
                    <span class="showdefaultunderline">
                      <!-- {{ print_data.file_no }} -->-
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="rowprpo">
              <div class="col-md-12report ml90prpo">
                <div class="col-md-6report textalignleft fixonerow">
                  &nbsp;&nbsp; Our Ref.: {{ print_data.file_no }}
                </div>
                <div class="col-md-6report textalignleft fixonerow">
                  &nbsp;&nbsp; Agent Ref.: {{ print_data.client_ref }}
                </div>
              </div>
            </div> -->
          </div>
        </page>
      </template>
      <v-dialog v-model="dialogprevie" max-width="600px">
        <v-card-text class="text-center">
          <v-row v-if="previews.length > 0">
            <v-carousel v-model="carouselIndex" hide-delimiter-background height="600" show-arrows show-arrows-on-hover
              hide-delimiters class="carousel-with-shadow" style="width: 600px">
              <v-carousel-item v-for="(src, index) in [...previews].reverse()" :key="index">
                <div class="image-wrapper-carousel">
                  <!-- preview image -->
                  <div class="counter-overlay">
                    {{ index + 1 }} / {{ previews.length }}
                  </div>
                  <img :src="src" class="preview-img-carousel" />

                  <!-- filename overlay -->
                  <div class="filename-overlay-carousel">
                    {{ imagenames[previews.length - 1 - index] }}
                  </div>

                  <!-- delete button -->
                </div>
              </v-carousel-item>
            </v-carousel>
          </v-row>
        </v-card-text>
      </v-dialog>

      <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />

      <SuccessDialogPush :status="dialogAdd" :text_color="text_color" :title="title" :message="message" :link="link" />
    </v-card>

    <!-- </v-card> -->
  </v-container>
</template>

<script>
const moment = require("moment-timezone");
import api from "@/services/api";
import {
  server,
  imagemasterTMUrl,
  filemasterTMUrl,
} from "@/services/constants";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import pdfvuer from "pdfvuer";
import html2pdf from "html2pdf.js";

export default {
  name: "MasterTrademark",
  async mounted() {
    this.$showLoader();
    await api.checkVersion();
    // ----------------- Check Authorize ---------------------------
    this.userId = localStorage.getItem(server.USER_ID);
    let yourUrlString = window.location;
    // alert(yourUrlString);

    let parser = document.createElement("a");
    parser.href = yourUrlString;

    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);
    // alert("authorize_id:" + this.authorize_id);
    if (this.authorize_id == null || this.authorize_id == 0) {
      // this.$router.push("/login");
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center"
      );
      this.$router.back();
    }

    const router_path = parser.pathname.replace("/", "");

    const res_auth = await api.getAuthorize(this.userId, router_path);

    // console.log("res_auth:" + JSON.stringify(res_auth.data));

    this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
    this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
    this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
    this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;

    // console.log("res_auth:" + JSON.stringify(res_auth.data));
    // console.log("authorize_view:" + this.authorize_view);
    // console.log("authorize_add:" + this.authorize_add);
    // console.log("authorize_edit:" + this.authorize_edit);
    // console.log("authorize_del:" + this.authorize_del);
    // this.$router.back();

    // ----------------- Check Authorize ---------------------------
    if (this.userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }
    if (!this.authorize_view) {
      this.$router.push("/not-found");
    }

    // ----------------- Check Authorize ---------------------------

    // await this.loaddatamastertmLimit200();
    this.$hideLoader();
    await this.loaddatatmupdatestatus();
    // await this.loaddatamastertmAll();
  },
  watch: {
    show: function (s) {
      if (s) {
        this.getPdf();
      }
    },
    // page: function(p) {
    //   if (
    //     window.pageYOffset <= this.findPos(document.getElementById(p)) ||
    //     (document.getElementById(p + 1) &&
    //       window.pageYOffset >= this.findPos(document.getElementById(p + 1)))
    //   ) {
    //     // window.scrollTo(0,this.findPos(document.getElementById(p)));
    //     document.getElementById(p).scrollIntoView();
    //   }
    // },
  },
  components: {
    SuccessDialog,
    SuccessDialogPush,
    pdf: pdfvuer,
  },
  data(vm) {
    const today = new Date();
    const todayStr = `${String(today.getDate()).padStart(2, "0")}/${String(
      today.getMonth() + 1
    ).padStart(2, "0")}/${today.getFullYear()}`;

    const plus30 = new Date();
    plus30.setDate(today.getDate() + 30);
    const plus30Str = `${String(plus30.getDate()).padStart(2, "0")}/${String(
      plus30.getMonth() + 1
    ).padStart(2, "0")}/${plus30.getFullYear()}`;

    // แปลง DD/MM/YYYY เป็น YYYY-MM-DD สำหรับ DatePicker
    const toYMD = (ddmmyyyy) => {
      const [dd, mm, yyyy] = ddmmyyyy.split("/");
      return `${yyyy}-${mm}-${dd}`;
    };
    return {
      carouselIndex: 0,
      images: [],
      previews: [],
      imagenames: [],
      dialogprevie: false,
      preview_mastertm_id: 0,
      preview_mastertm_file_no: "",
      menuadddatefrom: false,

      searchdatefrom: todayStr,
      searchdatefromPicker: toYMD(todayStr),
      menuadddateto: false,
      searchdateto: plus30Str,
      searchdatetoPicker: toYMD(plus30Str),
      tableLoading: false,

      item_per_page_list: [10, 20, 100, 200, 500, 1000],
      options: {
        page: 1,
        itemsPerPage: 200,
        sortBy: [],
        sortDesc: [],
      },
      // Pagination
      page: 1,
      pageCount: 0,
      itemsPerPage: 20,
      totalItems: 0,
      dataAll2: [],
      mDataArray2: [],

      userId: 0,
      authorize: [],
      authorize_view: false,
      authorize_add: false,
      authorize_edit: false,
      authorize_del: false,
      authorize_id: 0,
      search_tmp: "",
      showfilenameappointment: "",
      dialogAppointment: false,
      itemsPerPageArray: [10, 15, 20],
      pageSize: 3,
      pageSizes: [3, 6, 9],
      // pageCount: 0,
      // itemsPerPage: 100,
      load_bg: false,
      // page: 1,
      numPages: 0,
      pdfdata: undefined,
      errors: [],
      scale: "page-width",
      dialogEditmastertm: false,
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      dialogAddmastertm: false,
      dialogDelete: false,
      deletedItem: 0,
      deletedIndex: 0,
      isShowPassword: false,
      fullPage: true,
      datefrom: vm.formatDate(new Date().toISOString().substr(0, 10)),
      dateto: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dateCurrent: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      search: "",
      mDataArray: [],
      mDataArrayappointment: [],
      headers: [
        {
          text: "Object Type",
          value: "objecttype_code",
          divider: true,
          width: "250px",
        },
        {
          text: "File No.",
          align: "left",
          // sortable: false,
          value: "file_no",
          width: "120px",
          divider: true,
        },
        {
          text: "Application No.",
          value: "app_no",
          divider: true,
          width: "140px",
        },
        {
          text: "Country",
          value: "country",
          divider: true,
          width: "140px",
        },
        {
          text: "Registration No.",
          value: "regis_no",
          divider: true,
          width: "140px",
        },
        { text: "Class No.", value: "class_no", divider: true, width: "120px" },
        {
          text: "Trademark Name",
          value: "trademark",
          divider: true,
          width: "200px",
        },
        {
          text: "",
          value: "number_file",
          divider: true,
          width: "50px",
          align: "center",
        },
        {
          text: "Status",
          value: "tmupdatestatus_name",
          divider: true,
          width: "120px",
        },

        {
          text: "Client",
          value: "name_of_client",
          divider: true,
          width: "200px",
        },
        {
          text: "Agent Reference",
          value: "cliant_ref",
          divider: true,
          width: "200px",
        },
        // { text: "Mark Status", value: "tmupdatestatus_name", divider: true },
        // { text: "Client Ref", value: "cliant_ref", divider: true },
        // { text: "Owner", value: "owner_contact_name", divider: true },
        {
          text: "Agent",
          value: "agent_contact_name",
          divider: true,
          width: "200px",
        },
        // { text: "Next Renew", value: "date_of_renewal_show", divider: true },
        {
          text: "Associate",
          value: "associate_contact_name",
          divider: true,
          width: "200px",
        },
        {
          text: "New Renewal",
          value: "date_of_renewal_show",
          divider: true,
          align: "center",
          width: "150px",
        },
        {
          text: "",
          value: "actions",
          width: "200px",
          align: "left",
          divider: true,
        },
      ],
      headersappointment: [
        {
          text: "File No.",
          align: "left",
          // sortable: false,
          value: "refno",
          divider: true,
        },
        { text: "Application No.", value: "app_no", divider: true },
        { text: "Trademark Name", value: "trademark_name", divider: true },
        { text: "Agent", value: "agent_contact_name", divider: true },

        {
          text: "Work Type",
          align: "left",
          // sortable: true,
          value: "documenttype_code",
          width: "10%",
          divider: true,
        },
        { text: "Notice Type", value: "notice_name", divider: true },
        { text: "Final Deadline", value: "enddate", divider: true },
        { text: "Filed Date", value: "filed_date", divider: true },
        { text: "Status", value: "statusnow", divider: true },
        {
          text: "",
          value: "actions",
          width: "15%",
          align: "left",
          divider: true,
        },
      ],
      showprint: "display:none;",
      print_data: {},
      previewimageedit: null,
      tmstatus: 0,
      tmstatus_list: [],
      showtimelineData: [],
    };
  },
  methods: {
    editItemtimeline(item) {
      const url = `/appointmenttm-edit/${item.appointment_id}`; // หรือใส่ query ?file_no=xxx
      window.open(url, "_blank"); // เปิดหน้าใหม่
    },
    async openeAppoinmentOperationforClosed(data) {
      this.$showLoader();
      var restatus = await api.UpdateNewTm(data.mastertm_id, {
        tmstatusasoff: 1,
      });

      setTimeout(() => {
        this.onSearchPagination();
        this.$hideLoader();
      }, 500);
    },
    async previewTrademarkImage(data) {
      this.preview_mastertm_id = 0;
      this.preview_mastertm_file_no = "";
      var mastertm_id = data.mastertm_id;
      this.dialogprevie = true;
      this.preview_mastertm_id = mastertm_id;
      this.preview_mastertm_file_no = data.file_no;
      this.images = [];
      this.previews = [];
      this.imagenames = [];
      var data_search_tmimage = {
        tbl_id: Number(mastertm_id),
        tbl_name: "mattertm_image",
      };

      const resultTmimage = await api.getAllFileAtLawFile({
        params: data_search_tmimage,
      });

      if (resultTmimage.data.length > 0) {
        const existingTmimage = [];
        for (const [index, item] of resultTmimage.data.entries()) {
          let data = {
            id: item.id,
            name: item.file_name,
            type: item.file_type,
          };
          existingTmimage.push(data);
        }
        this.loadExistingFiles(existingTmimage, "Tmimage");
      }
    },
    loadExistingFiles(existingFiles, type) {
      if (!existingFiles || existingFiles.length === 0) return;

      const files = existingFiles.map((f) => {
        // สร้าง File object เปล่าสำหรับ preview
        const file = new File([], f.name, {
          type: f.type || "application/octet-stream",
        });
        // เพิ่ม property isNew เข้าไปใน File object
        file.isOld = true;
        file.id = f.id;
        return file;
      });

      switch (type) {
        case "Tmimage":
          this.images = files;
          // ✅ สำหรับ preview เก่า ใช้ path URL จริง ไม่ใช่ File object
          this.previews = files.map(
            (f) => `${imagemasterTMUrl}/${this.preview_mastertm_id}/${f.name}`
          );
          this.imagenames = files.map((f) => f.name);
          break;
      }
      console.log(this.previews)
      console.log(this.imagenames)
    },
    formatDateToDDMMYYYY(date) {
      if (!date) return "";
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    formatDateToYYYYMMDD(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
    // 3. แก้ไขฟังก์ชัน loaddataPagination
    async loaddatatmupdatestatus() {
      const result = await api.getAlltmupdatestatus();
      this.tmstatus_list = result.data;
    },
    async loaddataPagination() {
      var tmp = [];
      this.tableLoading = true;

      try {
        const result = await api.getAllMasterTMPagination(
          1,
          this.itemsPerPage,
          "contact_id",
          "ASC",
          this.search_tmp.trim()
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.limit;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 4. แก้ไขฟังก์ชัน onOptionsUpdate
    async onOptionsUpdate(options) {
      this.tableLoading = true;
      let tmp = [];
      let sortDesc = "";
      if (options.sortDesc[0] == true) {
        sortDesc = "ASC";
      } else {
        sortDesc = "DESC";
      }

      if (!options.sortBy[0]) {
        sortDesc = "ASC";
      }
      if (
        !this.searchdatefromPicker ||
        this.searchdatefromPicker == "" ||
        this.searchdatefromPicker == "null"
      ) {
        this.searchdatefromPicker = null;
      }
      if (
        !this.searchdatetoPicker ||
        this.searchdatetoPicker == "" ||
        this.searchdatetoPicker == "null"
      ) {
        this.searchdatetoPicker = null;
      }

      try {
        const result = await api.getAllMasterTMPagination(
          options.page,
          this.itemsPerPage,
          options.sortBy[0],
          sortDesc,
          this.search_tmp.trim(),
          this.tmstatus,
          this.searchdatefromPicker,
          this.searchdatetoPicker
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.limit;
        this.pageCount = result.data.pagination.totalPages;
        // console.log(this.mDataArray2);
        // this.mDataArray2 = this.mDataArray2.map((item) => {
        //   const images = item.master_images
        //     ? item.master_images.split(",").map((name) => {
        //         const fileName = name.trim();
        //         return {
        //           name: fileName,
        //           url: `${imagemasterTMUrl}/${item.mastertm_id}/${fileName}`, // ปรับ path ให้ตรงกับที่คุณเก็บไฟล์
        //         };
        //       })
        //     : [];

        //   return {
        //     ...item,
        //     master_image_list: images,
        //   };
        // });
      } catch (error) {
        console.error("Error updating options:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 5. แก้ไขฟังก์ชัน loadDataByPage
    async loadDataByPage(pageNumber) {
      this.tableLoading = true;
      let tmp = [];
      if (
        !this.searchdatefromPicker ||
        this.searchdatefromPicker == "" ||
        this.searchdatefromPicker == "null"
      ) {
        this.searchdatefromPicker = null;
      }
      if (
        !this.searchdatetoPicker ||
        this.searchdatetoPicker == "" ||
        this.searchdatetoPicker == "null"
      ) {
        this.searchdatetoPicker = null;
      }

      try {
        const result = await api.getAllMasterTMPagination(
          pageNumber,
          this.itemsPerPage,
          "contact_id",
          "ASC",
          this.search_tmp.trim(),
          this.tmstatus,
          this.searchdatefromPicker,
          this.searchdatetoPicker
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.limit;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error loading page data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 6. แก้ไขฟังก์ชัน onSearchPagination
    async onSearchPagination() {
      this.mDataArray2 = [];
      let tmp = [];
      this.page = 1;
      this.tableLoading = true;

      if (
        !this.searchdatefromPicker ||
        this.searchdatefromPicker == "" ||
        this.searchdatefromPicker == "null"
      ) {
        this.searchdatefromPicker = null;
      }
      if (
        !this.searchdatetoPicker ||
        this.searchdatetoPicker == "" ||
        this.searchdatetoPicker == "null"
      ) {
        this.searchdatetoPicker = null;
      }

      var s_data = {
        page: 1,
        limit: this.itemsPerPage,
        sortBy: "contact_id",
        sortDesc: "ASC",
        search: this.search_tmp.trim(),
        tmstatusasoff: this.tmstatus,
      };

      try {
        const result = await api.getAllMasterTMPagination(
          s_data.page,
          s_data.limit,
          s_data.sortBy,
          s_data.sortDesc,
          s_data.search,
          s_data.tmstatusasoff,
          this.searchdatefromPicker,
          this.searchdatetoPicker
        );
        // console.log(JSON.stringify(result.data));

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.limit;
        this.pageCount = result.data.pagination.totalPages;

        this.mDataArray2 = this.mDataArray2.map((item) => {
          const images = item.master_images
            ? item.master_images.split(",").map((name) => {
              const fileName = name.trim();
              return {
                name: fileName,
                url: `${imagemasterTMUrl}/${item.mastertm_id}/${fileName}`, // ปรับ path ให้ตรงกับที่คุณเก็บไฟล์
              };
            })
            : [];

          return {
            ...item,
            master_image_list: images,
          };
        });
      } catch (error) {
        console.error("Error searching data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    async openPrintAppNo(item) {
      this.$showLoader();
      this.print_data = {};
      this.previewimageedit = null;
      await this.genimage(item);
      this.print_data = item;

      var dataAdd = {
        user_id: localStorage.getItem(server.USER_ID),
        log_in_out_id: localStorage.getItem(server.LOGIN_ID),
        action: "Export",
        table_name: "mastertm",
        table_id: item.mastertm_id,
        date: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
      };

      await api.addTransectionLog(dataAdd);

      var dataEditLog = {
        last_update: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
      };
      await api.updateLogInOutLog(
        localStorage.getItem(server.LOGIN_ID),
        dataEditLog
      );

      setTimeout(async () => {
        await this.exportToPDF();
        this.$hideLoader();
      }, "2000");
    },
    async genimage(item) {
      this.previewimageedit = `${imagemasterTMUrl}/${item.mastertm_id}/${item.master_images}`;
    },

    openInNewTab(url) {
      window.open(url, "_blank");
    },
    async exportToPDF(advance_id) {
      // this.$refs.html2Pdf.generatePdf();

      this.showprint = "";
      let element = document.getElementById("mydivhtmltobase");
      const opt = {
        margin: [0, 0, 0, 0],
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        // enableLinks: false,
        html2canvas: {
          scale: 2,
          dpi: 192,
          letterRendering: true,
          useCORS: true,
          // ignoreElements: (e) => {
          //   return e.classList.contains("cke_pagebreak") ||
          //     e.classList.contains("html2pdf__page-break")
          //     ? true
          //     : false;
          // },
        },
        jsPDF: {
          unit: "cm",
          format: "A4",
          orientation: "portrait",
          putOnlyUsedFonts: true,
          pagesplit: true,
        },
        // pagebreak: { mode: ["avoid-all"], after: ".cke_pagebreak" },
      };

      let abcd = await html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .get("pdf")
        // .output("bloburl")
        .then(function (pdf) {
          console.log(pdf);
          const totalPages = pdf.internal.getNumberOfPages();
          pdf.deletePage(totalPages);
          return pdf.output("bloburl");
        });
      // console.log(abcd);
      window.open(abcd);
      let blob = await fetch(abcd).then((r) => r.blob());
      this.showprint = "display:none;";

      return;
    },
    async openeditTableAppointment(appointment_id) {
      window.open(`/appointmenttm-edit/${appointment_id}`);
    },
    // 7. แก้ไขฟังก์ชัน onSearch (สำหรับ search box)
    async onSearch() {
      this.tableLoading = true;

      try {
        const result = await api.getMasterTMSearch({
          params: { search_tmp: this.search_tmp.trim() },
        });
        this.mDataArray = result.data;
      } catch (error) {
        console.error("Error searching:", error);
      } finally {
        this.tableLoading = false;
      }
    },
    async loaddatamastertmLimit200() {
      // this.$showLoader();

      const result = await api.getAllMasterTMLimit200();
      console.log(result.data);
      // const result = await api.getAllMasterTM();
      this.mDataArray = result.data;
      // this.$hideLoader();
    },
    async loaddatamastertmAll() {
      // this.$showLoader();
      this.load_bg = true;
      const result = await api.getAllMasterTM();
      console.log(result.data);
      // const result = await api.getAllMasterTM();
      this.mDataArray = this.mDataArray.concat(result.data);

      // this.$hideLoader();
      // alert("load data success");
      // alert(this.mDataArray.length);
      this.load_bg = false;
    },
    async openAppointmentedit(file_no) {
      this.showtimelineData = [];
      this.$showLoader();

      var resTimeline = await api.gettimelinemastertm({
        file_no: file_no.trim(),
      });
      var datalist = [];
      if (resTimeline.data && resTimeline.data.length > 0) {
        for (const [index, item] of resTimeline.data.entries()) {
          console.log(item)
          if (Number(item.doctype) == 7) {
            item.show_date = `Application Date - ${item.receive_date}`;
            item.sort_date = item.receive_date;
          } else if (
            [
              1, 2, 4, 5, 6, 8, 9, 10, 19, 104, 105, 108, 109, 110, 111, 112,
              113, 701, 702, 801, 802, 1002, 1003, 1004, 1005, 1006, 1007, 1009,
              1010, 1011,
            ].includes(Number(item.doctype))
          ) {
            item.show_date = `Submitted Date - ${item.filling_date}`;
            item.sort_date = item.filling_date;
          } else if (Number(item.doctype) == 3) {
            item.show_date = `Renewal Filed Date - ${item.receive_date}`;
            item.sort_date = item.receive_date;
          }

          datalist.push(item);
        }

        const sortedData = datalist.sort((a, b) => {
          // ถ้า a ไม่มี sort_date → ไปหลังสุด
          if (!a.sort_date && b.sort_date) return 1;
          // ถ้า b ไม่มี sort_date → ไปหลังสุด
          if (a.sort_date && !b.sort_date) return -1;
          // ถ้าทั้งคู่ไม่มี sort_date → เท่ากัน
          if (!a.sort_date && !b.sort_date) return 0;

          // แยกวันที่
          const partsA = a.sort_date.split("/");
          const partsB = b.sort_date.split("/");

          // ถ้า format ไม่ครบ → ไปหลังสุด
          if (partsA.length !== 3 || partsB.length !== 3) return 0;

          const [dayA, monthA, yearA] = partsA.map(Number);
          const [dayB, monthB, yearB] = partsB.map(Number);

          const dateA = new Date(yearA, monthA - 1, dayA);
          const dateB = new Date(yearB, monthB - 1, dayB);

          return dateB - dateA; // เรียงจากใหม่ → เก่า
        });

        this.showtimelineData = sortedData;
      }

      this.$hideLoader();
      this.dialogAppointment = true;

      // localStorage.setItem(server.MODELMENU, 6);
      // this.$router.push(`/appointment-trademark-list`);
    },
    async closedialogAppointment() {
      this.dialogAppointment = false;
    },
    async openAppointmentadd(file_no) {
      localStorage.setItem(server.MODELMENU, 6);
      // this.$router.push(`/appointmenttm-add/${file_no}`);
      window.open(`/appointmenttm-add/${file_no}/null`);
    },
    async openeditItem(mastertm_id) {
      // this.$router.push(`/master-trademark-edit/${mastertm_id}`);
      window.open(`/master-trademark-edit/${mastertm_id}`);
    },

    deleteItem(item) {
      this.deletedIndex = this.mDataArray.indexOf(item);
      console.log(item.mastertm_id);
      this.deletedItem = item.mastertm_id;
      this.dialogDelete = true;
    },
    closeDelete() {
      this.deletedItem = 0;
      this.dialogDelete = false;
    },
    async deleteItemConfirm() {
      this.$showLoader();
      this.mDataArray.splice(this.deletedIndex, 1);
      this.dialogDelete = false;
      let setflag = 1;
      // 1 = delete
      const resdel = await api.updateMasterTMDel(this.deletedItem, {
        updatestatus: setflag,
      });
      // const resdel = await api.deleteMasterTM(this.deletedItem);
      console.log(resdel);
      if (resdel.status == 200 || resdel.status == 201) {
        var dataAdd = {
          user_id: localStorage.getItem(server.USER_ID),
          log_in_out_id: localStorage.getItem(server.LOGIN_ID),
          action: "Delete",
          table_name: "mastertm",
          table_id: Number(this.deletedIndex) + 1,
          date: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
        };

        await api.addTransectionLog(dataAdd);

        var dataEditLog = {
          last_update: moment()
            .tz("Asia/Bangkok")
            .format("YYYY-MM-DD HH:mm:ss"),
        };
        await api.updateLogInOutLog(
          localStorage.getItem(server.LOGIN_ID),
          dataEditLog
        );

        // this.loaddatadetails();
        this.closeDelete();
        this.$hideLoader();
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          true,
          "delete data",
          "delete data success",
          "text-h5 green--text text-center",
          "/reloadpage"
        );
        return;
      } else {
        // this.loaddatadetails();
        this.closeDelete();
        this.$hideLoader();
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "delete data",
          "can't delete data",
          "text-h5 red--text text-center"
        );
        return;
      }
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${year}-${month - 1}-${day}`;
    },

    async setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    async setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
  beforeCreate() {
    console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },
};
</script>

<style scoped>
.widthbtnimagefile {
  width: 40%;
}

.widthsizesearch {
  width: 70%;
}

.heightsizesearch {
  height: 45%;
}

.heightrow {
  height: 70%;
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}

.btnuploadfile {
  border: 2px solid;
}

h3 {
  font-size: 1.17em;
}

h4 {
  font-size: 0.875rem;
}

body {
  background: rgb(204, 204, 204);
}

.page {
  background: white;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.5cm;
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
}

.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}

.page[size="A4"][layout="landscape"] {
  width: 29.7cm;
  height: 21cm;
}

.page[size="A3"] {
  width: 29.7cm;
  height: 42cm;
}

.page[size="A3"][layout="landscape"] {
  width: 42cm;
  height: 29.7cm;
}

.page[size="A5"] {
  width: 14.8cm;
  height: 21cm;
}

.page[size="A5"][layout="landscape"] {
  width: 21cm;
  height: 14.8cm;
}

@page {
  size: 7in 9.25in;
  margin: 27mm 16mm 27mm 16mm;
}

page {
  position: relative;
  background: white;
  display: block;
  margin: 0 auto;
  line-height: 1.5;
  /* margin-bottom: 0.5cm; */
  border: 1px solid;
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
  font-family: "EscrowCond-Roman";
}

page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}

page[size="A4"][layout="portrait"] {
  width: 29.7cm;
  height: 21cm;
}

@media print {

  body,
  page {
    margin: 0;
    box-shadow: 0;
  }

  html,
  body {
    width: 210mm;
    height: 297mm;
  }
}

.page {
  font-family: "EscrowCond-Roman";
  display: inline-block;
  position: relative;
  height: 297mm;
  width: 210mm;
  font-size: 12pt;
  margin: 2em auto;
  padding: calc(var(--bleeding) + var(--margin));
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
  background: white;
}

@media screen {
  .page::after {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    width: calc(100% - var(--bleeding) * 2);
    height: calc(100% - var(--bleeding) * 2);
    margin: var(--bleeding);
    /* outline: thin dashed black; */
    pointer-events: none;
    z-index: 9999;
  }
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}

.btnuploadfile {
  border: 2px solid;
}

.v-btn:not(.v-btn--round).v-size--default.buttonred {
  width: 100%;
  background-color: #9e3b1b;
  color: white;
}

.v-btn:not(.v-btn--round).v-size--default.buttonwhite {
  width: 100%;
  background-color: #f5f5f5;
  color: black;
}

h3 {
  font-size: 1.17em;
}

h4 {
  font-size: 1em;
}

.test {
  border-style: double;
}

.borderblack {
  border-style: solid;
  border-width: thin;
}

.mt-50 {
  margin-top: 50px;
}

.mb-50 {
  margin-bottom: 50px;
}

.btn-light {
  color: #333;
  background-color: #fafafa;
  border-color: #ddd;
}

@media (min-width: 768px) {
  .wmin-md-400 {
    min-width: 400px !important;
  }
}

.btn-primary {
  color: #fff;
  background-color: #2196f3;
}

.btn-labeled>b {
  position: absolute;
  top: -1px;
  background-color: blue;
  display: block;
  line-height: 1;
  padding: 0.62503rem;
}

.alignleft {
  float: left;
}

.alignright {
  float: right;
}

.aligncenter {
  text-align: center;
}

.captionreport {
  font-size: 0.85rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "EscrowCond-Roman";
}

.caption {
  font-size: 0.75rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "EscrowCond-Roman";
}

.captionhtable {
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "EscrowCond-Roman";
}

.rowprpo {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  margin-right: -12px;
  margin-left: -12px;
}

.colprpo {
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  max-width: 100%;
}

.col-md-1report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 8.333333333333333%;
  flex: 0 0 8.333333333333333%;
  max-width: 8.333333333333333%;
}

.col-md-2report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 16.66666666666667%;
  flex: 0 0 16.66666666666667%;
  max-width: 16.66666666666667%;
}

.col-md-3report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 25%;
  flex: 0 0 25%;
  max-width: 25%;
}

.col-md-4report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 33.33333333333333%;
  flex: 0 0 33.33333333333333%;
  max-width: 33.33333333333333%;
}

.col-md-5report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 41.66666666666667%;
  flex: 0 0 41.66666666666667%;
  max-width: 41.66666666666667%;
}

.col-md-6report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.col-md-7report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 58.33333333333333%;
  flex: 0 0 58.33333333333333%;
  max-width: 58.33333333333333%;
}

.col-md-8report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 66.66666666666667%;
  flex: 0 0 66.66666666666667%;
  max-width: 66.66666666666667%;
}

.col-md-9report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 75%;
  flex: 0 0 75%;
  max-width: 75%;
}

.col-md-10report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 83.33333333333333%;
  flex: 0 0 83.33333333333333%;
  max-width: 83.33333333333333%;
}

.col-md-11report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 91.66666666666667%;
  flex: 0 0 91.66666666666667%;
  max-width: 91.66666666666667%;
}

.col-md-12report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}

.mt-5prpo {
  margin-top: -5px !important;
}

.mt-30prpo {
  margin-top: -30px !important;
}

.mt30 {
  margin-top: 30px !important;
}

.mt20 {
  margin-top: 20px !important;
}

.mt10 {
  margin-top: 10px !important;
}

.mt25 {
  margin-top: 25px !important;
}

.mt-25prpo {
  margin-top: -25px !important;
}

.mr30prpo {
  margin-right: 30px !important;
}

.ml30prpo {
  margin-left: 30px !important;
}

.ml2prpo {
  margin-left: 2px !important;
}

.ml10prpo {
  margin-left: 10px !important;
}

.ml-40prpo {
  margin-left: -40px !important;
}

.borderblockpr {
  border: 1px solid black;
  width: 600px;
  height: 80px;
  /* background: white; */
  /* box-sizing: border-box; */
  display: inline-block;
}

.col-md-4pr {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 30%;
  flex: 0 0 30%;
  max-width: 30%;
}

.col-md-8pr {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 70%;
  flex: 0 0 70%;
  max-width: 70%;
}

.col-md-4prrd {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.col-md-8prrd {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.textalignleft {
  text-align: left;
}

.textalignright {
  text-align: right;
}

.textaligncenter {
  text-align: center;
}

table {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
  /* border: 1px solid black; */
}

.prbordertop {
  border-top: 1px solid black;
}

.prborderbottom {
  border-bottom: 1px solid black;
}

.prbordertop2pxhtable {
  padding-top: 8px;
  /* border-top: 1px solid black; */
}

.prborderbottom2pxhtable {
  padding-bottom: 8px;
  border-bottom: 1px solid black;
}

td {
  /* border: 1px solid black; */
}

td.tdborder-top {
  border-top: 1px solid black;
}

td.tdborder-right {
  border-right: 1px solid black;
}

td.tdborder-left {
  border-left: 1px solid black;
}

td.tdborder-bottom {
  border-bottom: 1px solid black;
}

th {
  /* border: 1px solid black; */
}

th.thborder-top {
  border-top: 1px solid black;
}

th.thborder-right {
  border-right: 1px solid black;
}

th.thborder-left {
  border-left: 1px solid black;
}

th.thborder-bottom {
  border-bottom: 1px solid black;
}

.width15 {
  word-wrap: break-word;
  width: 15%;
}

.width10 {
  word-wrap: break-word;
  width: 10%;
}

.width20 {
  word-wrap: break-word;
  width: 20%;
}

.width30 {
  word-wrap: break-word;
  width: 30%;
}

.width40 {
  word-wrap: break-word;
  width: 40%;
}

.width50 {
  word-wrap: break-word;
  width: 50%;
}

.width60 {
  word-wrap: break-word;
  width: 60%;
}

.width70 {
  word-wrap: break-word;
  width: 70%;
}

.width75 {
  word-wrap: break-word;
  width: 75%;
}

.width80 {
  word-wrap: break-word;
  width: 80%;
}

.width85 {
  word-wrap: break-word;
  width: 85%;
}

.width90 {
  word-wrap: break-word;
  width: 90%;
}

.width98 {
  word-wrap: break-word;
  width: 98%;
}

.width100 {
  word-wrap: break-word;
  width: 100%;
}

@media print {

  /*
          body.A3.landscape { width: 420mm }
          body.A3, body.A4.landscape { width: 297mm }
          body.A4, body.A5.landscape { width: 210mm }
          body.A5 { width: 148mm }*/
  .printonly {
    display: block;
  }

  .noprint {
    display: none;
  }

  .A3.landscape {
    width: 420mm;
  }

  .A3,
  .A4.landscape {
    width: 297mm;
  }

  .A4,
  .A5.landscape {
    width: 210mm;
  }

  .A5 {
    width: 148mm;
  }
}

header {
  top: 0;
  padding-top: 150mm;
  padding-bottom: 3mm;
}

footer {
  bottom: 0;
  color: #000;
  padding-top: 3mm;
  padding-bottom: 5mm;
}

header,
footer {
  /* position: fixed; */
  left: 0;
  right: 0;
  background-color: #ccc;
  padding-right: 1.5cm;
  padding-left: 1.5cm;
}

.footerprpo {
  position: absolute;
  bottom: 10px;
  width: 100%;
}

.borderauto {
  border: 1px solid;
  margin: -1px;
}

.bordersignature {
  height: 110px;
  border: 1px solid;
  margin: -1px;
}

.fixfourrow {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  height: 80px;
  overflow: hidden;
  text-align: left;
}

.fixthreerow {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  height: 60px;
  overflow: hidden;
  text-align: left;
}

.fixtworow {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 40px;
  overflow: hidden;
  text-align: left;
}

.fixonerow {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 20px;
  overflow: hidden;
  text-align: left;
}

.fixonerowcenter {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 20px;
  overflow: hidden;
  text-align: center;
}

.fontsize10 {
  font-size: 10px;
}

.fontsize12 {
  font-size: 12px;
}

.fontsize13 {
  font-size: 12px;
}

.fontsize14 {
  font-size: 14px;
}

.borderwidththin {
  border-width: thin;
}

.titledatadetailintable {
  font-weight: bold;
  text-decoration: underline;
}

.paddingleftintable {
  padding-left: 10px;
}

.paddingrightintable {
  padding-right: 10px;
}

.wordspacingsummary {
  /* word-spacing: -1px; */
  letter-spacing: 1px;
}

.ml170-prpo {
  margin-left: -170px !important;
}

.mr95prpo {
  margin-right: 95px !important;
}

.ml95prpo {
  margin-left: 95px !important;
}

.mr80prpo {
  margin-right: 80px !important;
}

.ml80prpo {
  margin-left: 80px !important;
}

.mr120prpo {
  margin-right: 120px !important;
}

.ml120prpo {
  margin-left: 120px !important;
}

.showdefaultunderline {
  /* display: table-cell;
  border-bottom: 1px solid black; */
  font-weight: bold;
  text-decoration: underline;
}

.ml10-prpo {
  margin-left: -10px !important;
}

.mr10-prpo {
  margin-right: -10px !important;
}

.ml20-prpo {
  margin-left: -20px !important;
}

.mr20-prpo {
  margin-right: -20px !important;
}

.mr30-prpo {
  margin-right: -30px !important;
}

.ml30-prpo {
  margin-left: -30px !important;
}

.preview-btn {
  border-radius: 20px;
  /* มุมโค้ง */
  text-transform: none;
  /* ไม่เปลี่ยนข้อความเป็นพิมพ์ใหญ่ */
  font-weight: 500;
  /* น้ำหนักตัวอักษร */
  padding: 6px 14px;
  /* ระยะห่างภายใน */
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  /* เงานุ่ม ๆ */
  transition: all 0.25s ease;
}

.preview-btn:hover {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  transform: translateY(-2px);
  /* ยกปุ่มขึ้นเล็กน้อยเวลา hover */
}

.preview-btn:active {
  transform: translateY(0);
  /* กดลงกลับที่เดิม */
}

.carousel-with-shadow {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  overflow: hidden;
}

.image-wrapper-carousel {
  position: relative;
  width: 600px;
  /* ใช้ความกว้างเป็นหลัก */
  height: 600px;
  /* ความสูงคงที่ */
  display: flex;
  justify-content: center;
  /* จัดกลางแนวนอน */
  align-items: center;
  /* จัดกลางแนวตั้ง */
  overflow: hidden;
  /* ซ่อนส่วนเกินของรูป */
  border-radius: 8px;
  background-color: #f5f5f5;
  /* สีพื้นหลังถ้ารูปเล็ก */
}

/* รูป */
.preview-img-carousel {
  width: 100%;
  /* ความกว้างเต็ม wrapper */
  height: auto;
  /* ความสูงปรับตามอัตราส่วน */
  max-height: 100%;
  /* ไม่เกินความสูง wrapper */
  object-fit: contain;
  /* ยังคงอัตราส่วน */
  cursor: pointer;
}

/* ชื่อไฟล์ overlay ติดขอบล่าง */
.filename-overlay-carousel {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 4px 8px;
  font-size: 14px;
  text-align: center;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  z-index: 5;
}

/* ตัวเลขนับรูป */
.counter-overlay {
  position: absolute;
  top: 5px;
  /* อยู่ด้านบน */
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 14px;
  z-index: 10;
}

/* carousel มีเงา */
.carousel-with-shadow {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  overflow: hidden;
}
</style>
